function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();

}

function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
}

//attach video listener
$('[data-text-animation] video').each(function(){
  let lastTime = 0;
  let _this = $(this)[0];
  let parent = _this.closest('[data-text-animation]');
  let animationElements = parent.querySelectorAll('.js-animation-container span');
  function restartAnimation(){
    parent.classList.add('is-animating');
    for (let i = 0; i < animationElements.length; i++) {
      let el = animationElements[i];
      
      let container = el.closest('.animation-container');
      let height = container.offsetHeight;
      const bottom_margin = 15;

      container.style.top = (height + bottom_margin) * -1 + "px";
      el.classList.remove('animate');
      el.offsetWidth
      el.classList.add("animate")
    }
  }

  function removeAnimation(){
    parent.classList.remove('is-animating');
    for (let i = 0; i < animationElements.length; i++) {
      let el = animationElements[i];
      el.classList.remove('animate');
    }
  }


  $(this).on("timeupdate", function(){
    var currentTime = this.currentTime;
    if(currentTime < lastTime){
        //alert("looping");
        restartAnimation()
    }
    lastTime = currentTime;
  });

  $(this).on('play', function(){
    restartAnimation()
  })

  $(this).on('pause', function(){
    removeAnimation()
  })
})

var Cookies = (function () {
  return {
    set: function (cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires;
    },
    get: function (cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    check: function (name) {
      let cookie = Cookies.get(name);
      if (cookie != "") {
        return true;
      } else {
        return false;
      }
    },
  };
})();


//BV script to hide reviews
//wait for BV to load
function BVLoader(BVinit){
  
  if(typeof BV != 'undefined'){
    BVinit();
    console.log('BV init')
  }else{
    setTimeout(function() { 
      BVLoader(BVinit);
      console.log('Waiting for BV...')
    }, 500)
  }
}

function BVinit(){
  
  setTimeout(function() { 
    hideZeroReviews();
  }, 5000)
  

}

//hide zero reviews in the website
function hideZeroReviews(){
  $('[data-bv-show="inline_rating"]').each(function(){
    let $container = $(this).find('.bv_numReviews_component_container .bv_text');
    let numRating = $container.text();
    let zeroString = "(0)";
    if($container.length == 0 || numRating == zeroString ){
      $(this).hide();
      
    }
  })

  $('[data-bv-show="rating_summary"]').each(function(){
    let $container = $(this).find('.bv_numReviews_component_container .bv_numReviews_text');
    let numRating = $container.text();
    let zeroString = "(0)";
    if($container.length == 0 || numRating == zeroString ){
      $(this).hide();
      $(this).parents('.product__badge').hide();
    }
  })
  console.log('Hide BV Zero Reviews');
}

//BVLoader(BVinit);

// end BV script

//handle lazyloading of videos
document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === "string" &&
              videoSource.tagName === "SOURCE"
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          video.target.classList.add("lazyloaded");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});


const handleAnalyticsClick = function(e){

  console.log('analytics click', e);

  var event_name = $(this).data('analytics-name');
  var product = $(this).data('product') || "";

  
  /*
  window.dataLayer.push({
    event: event_name,
    page: window.location.href,
    product: product
  });
  */

  if(!event_name || event_name == "") return;

  console.log('analytics sent', event_name, product);

  gtag('event', event_name, {
    'send_to': 'G-VG2CT9E4GV',
    'page': window.location.href,
    'product': product
  });
}

//analytics event listener
$(document).on('click', '.js-analytics-trigger', handleAnalyticsClick)




//accordion for footer (mobile only) -- must NOT be exposed as clickable on desktop,
//where the accordion is inactive (otherwise NVDA announces the footer headings as "clickable").
(function () {
  var footerAccordionMQ = window.matchMedia("(max-width: 767px)");
  var $accordions = $(".mobile-footer-accordion");

  function toggleFooterAccordion() {
    $(this).toggleClass("open");
    $(this).find(".footer__quicklinks").slideToggle(400);
  }

  function syncFooterAccordion(mq) {
    $accordions.off("click.footerAcc");
    if (mq.matches) {
      // Mobile: keep the existing tap-to-toggle behavior
      $accordions.on("click.footerAcc", toggleFooterAccordion);
    } else {
      // Desktop: no click handler (headings are plain, not "clickable"); clear any
      // inline display slideToggle may have left so the links render normally.
      $accordions.removeClass("open").find(".footer__quicklinks").css("display", "");
    }
  }

  syncFooterAccordion(footerAccordionMQ);
  if (footerAccordionMQ.addEventListener) {
    footerAccordionMQ.addEventListener("change", syncFooterAccordion);
  } else if (footerAccordionMQ.addListener) {
    footerAccordionMQ.addListener(syncFooterAccordion); // Safari < 14
  }
})();

//header promotion slider -- delete 
var promotionSliderWrapper = $("#shopify-section-promotion-slider");
var $promotionSlider = $(".promotion-slider-container", promotionSliderWrapper);

var initPromotionSlider = function () {
  if (!$promotionSlider.length || $promotionSlider.hasClass("slick-initialized")) {
    return;
  }

  $promotionSlider.on(
    "init",
    function (slick) {
      //set contents to be visible
      $(
        ".promotion-slider-container .promotion-content",
        promotionSliderWrapper
      ).show();
    }
  );

  $promotionSlider.slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    prevArrow:
      '<a class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
    nextArrow:
      '<a class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });
};

if ($promotionSlider.length) {
  if (window.theme && window.theme.whenSlickReady) {
    window.theme.whenSlickReady(initPromotionSlider);
  } else if ($.fn && $.fn.slick) {
    initPromotionSlider();
  }
}



//LOCK ATC
$(document).on("click", ".js-lock-cta", function (e) {
  e.preventDefault();
  var lock_type = $(this).data("lock-type");
  var $lock_element = $("#product-main-widget-wrapper");
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $lock_element.offset().top - 150,
    },
    300
  );

  if (lock_type == "members_only") {
    var $lock_form = $("#product-lock-signup-form-wrapper");

    if ($lock_form.is(":hidden")) {
      $lock_form.slideDown(400);
      return;
    } else {
      $lock_form.addClass("focus");
    }
  }

  //$lock_element.addClass("focus");
});


/* SLIDE TOGGLE UTILITY */
function slideToggle(element, duration = 400, callback) {
  if (!element) return;

  const isHidden = window.getComputedStyle(element).display === 'none';

  if (isHidden) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;

    const height = element.scrollHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.offsetHeight; // force repaint

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      if (typeof callback === 'function') callback();
    }, duration);
  } else {
    element.style.overflow = 'hidden';
    element.style.height = element.scrollHeight + 'px';
    element.offsetHeight; // force repaint

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0px';

    setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition');
      if (typeof callback === 'function') callback();
    }, duration);
  }
}



var ThemeUtils = (function () {
  return {
    isDarkColor: function (color) {
      var c = color.substring(1); // strip #
      var rgb = parseInt(c, 16); // convert rrggbb to decimal
      var r = (rgb >> 16) & 0xff; // extract red
      var g = (rgb >> 8) & 0xff; // extract green
      var b = (rgb >> 0) & 0xff; // extract blue

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      //color is too dark
      if (luma < 40) {
        return true;
      }

      return false;
    },
    escapeEntity: function (string) {
      var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };

      return String(string).replace(/[&<>"'`=/]/g, function (s) {
        return entityMap[s];
      });
    },
  };
})();


$('.product-buy-now-button, .js-product-buy-now-button').click(function(e){
  e.preventDefault();
  $('.product-single-atc.add-js').trigger('click');
});

/* ADD TO CART GOOGLE ADS TRIGGER */
function googleAdsReportATC(conversionValue) {

  gtag('event', 'conversion', {
      'send_to': 'AW-852272556/Ht9eCLqAjO4ZEKzLspYD',
      'value': conversionValue || 1.0,
      'currency': window.theme.currency || "USD",
      'event_callback': function () {
        
      }
  });
  return false;
}
/* END ADD TO CART GOOGLE ADS TRIGGER */


//CODEAGE AI CONSTANTS
var CODEAGEAICONST = (function () {
  return {
    messageRoles: {
      HUMAN: 'human',
      AI: 'ai'
    },
    messageStatus: {
      SENDING: 'sending',
      ERROR: 'error',
      SENT: 'sent'
    },
    events: {
      CHAT_ADD: 'codeageai.chat.add'
    }
  }
})();

//trigger jarallax video because it's on defer
//jarallaxVideo();


// tiny util you can share between modules
function pushStateMerge(partial, url = undefined) {
  const current = history.state || {};
  const next = { ...current, ...partial };
  history.pushState(next, '', url);
}

function replaceStateMerge(partial, url = undefined) {
  const current = history.state || {};
  const next = { ...current, ...partial };
  history.replaceState(next, '', url);
}
  



/* DETECT DEVICE */
(function () {
  const ua = navigator.userAgent;
  const lower = ua.toLowerCase();

  // --- OS detection ---------------------------------------------------------
  function detectOS() {
    // iOS (includes iPadOS with desktop UA)
    const isiOSUA = /\b(iPhone|iPad|iPod)\b/.test(ua);
    const isiPadDesktopUA = !isiOSUA &&
      navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (isiOSUA || isiPadDesktopUA) {
      // Try "OS 16_5" first (classic iOS UA)
      let m = ua.match(/OS (\d+)[._](\d+)?[._]?(\d+)?/);
      if (m) {
        return { os: 'ios', major: +m[1], minor: +(m[2] || 0), patch: +(m[3] || 0) };
      }
      // iPad with desktop UA sometimes lacks the "OS" token; fall back to Safari Version
      m = ua.match(/Version\/(\d+)\.(\d+)/); // close to iOS major/minor on iPadOS
      if (m) {
        return { os: 'ios', major: +m[1], minor: +m[2], patch: 0 };
      }
      return { os: 'ios', major: null, minor: null, patch: null };
    }

    // Android
    if (/\bAndroid\b/i.test(ua)) {
      const m = ua.match(/Android\s+(\d+)(?:\.(\d+))?/i);
      return { os: 'android', major: m ? +m[1] : null, minor: m ? +(m[2] || 0) : null, patch: null };
    }

    return { os: 'unknown', major: null, minor: null, patch: null };
  }

  // --- Browser detection -----------------------------------------------------
  function detectBrowser() {
    // iOS tokens for non-Safari browsers
    if (/CriOS/i.test(ua))   return 'chrome';
    if (/FxiOS/i.test(ua))   return 'firefox';
    if (/EdgiOS/i.test(ua))  return 'edge';
    if (/OPiOS|Opera/i.test(ua)) return 'opera';
    if (/DuckDuckGo/i.test(ua))  return 'duckduckgo';

    // Android / general tokens
    if (/SamsungBrowser/i.test(ua)) return 'samsung';
    if (/\bEdgA?\//i.test(ua))      return 'edge';
    if (/OPR\//i.test(ua))          return 'opera';
    if (/Firefox\//i.test(ua))      return 'firefox';
    if (/Chrome\//i.test(ua))       return 'chrome';

    // Safari (must come after iOS alt browsers; many UAs contain "Safari")
    if (/Safari\//.test(ua) && /Version\//.test(ua)) return 'safari';

    return 'unknown';
  }

  // --- WebView / in‑app heuristic (optional class) --------------------------
  function detectWebView(os, browser) {
    // iOS WebView lacks "Version/" token; common apps add markers
    if (os === 'ios') {
      const isSafari = /Safari\//.test(ua) && /Version\//.test(ua);
      const inAppMarkers = /(FBAN|FBAV|Instagram|Line|Twitter|Pinterest|GSA)/i.test(ua);
      return !isSafari || inAppMarkers;
    }
    // Android WebView has "wv" or "Version/X"
    if (os === 'android') {
      return /\bwv\b/.test(lower) || /; wv\)/.test(lower) || /Version\/\d+\.\d+/i.test(ua);
    }
    return false;
  }

  const osInfo = detectOS();
  const browser = detectBrowser();
  const isWebView = detectWebView(osInfo.os, browser);

  // --- Build class names -----------------------------------------------------
  function slug(parts) {
    return parts
      .filter(Boolean)
      .join('-')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')   // sanitize
      .replace(/-+/g, '-')            // collapse dashes
      .replace(/^-|-$/g, '');         // trim
  }

  const classes = new Set();

  // Granular classes
  classes.add(slug(['os', osInfo.os || 'unknown']));
  classes.add(slug(['browser', browser]));
  if (osInfo.major != null) {
    classes.add(slug(['osver', String(osInfo.major)]));
    if (osInfo.minor != null) {
      classes.add(slug(['osver', String(osInfo.major), String(osInfo.minor)])); // e.g. osver-16-6
    }
  }
  if (isWebView) classes.add('is-webview'); else classes.add('is-browser');

  // Combined convenience class: env-ios-safari-16
  if (osInfo.os && browser && osInfo.major != null) {
    classes.add(slug(['env', osInfo.os, browser, String(osInfo.major)]));
  }

  // Apply to body (or html if body not ready yet — then mirrored on DOMContentLoaded)
  const target = document.body || document.documentElement;
  target.classList.add(...classes);

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.add(...classes);
    });
  }
})();
